function _sortFunc (a, b) {
  return a.sort - b.sort
}

export function listToTree (srcList, destList, sortFunc = _sortFunc, repare = true) {
  if (!destList) {
    destList = []
  } else {
    destList.splice(0, destList.length)
  }
  if (!srcList) return destList
  const nodeData = {}
  srcList.forEach(item => {
    if (item.name) {
      item.label = item.name
      item.value = item.id
    }
    item.children = []
    nodeData[item.id] = item
  })
  srcList.forEach(item => {
    if (item.parentId) {
      const parent = nodeData[item.parentId]
      if (parent) {
        parent.children.push(item)
        parent.children.sort(sortFunc)
        return
      }
      if (!parent && repare) {
        item = {}
        return
      }
    }
    destList.push(item)
  })
  destList.sort(sortFunc)
  return destList
}
export function formatTime (timestamp, format = 'yyyy-MM-dd HH:mm') {
  const formatNum = num => {
    return String(num).padStart(2, '0')
  }
  const date = new Date(timestamp)
  return format.replace(/yyyy/g, date.getFullYear())
    .replace(/MM/g, formatNum(date.getMonth() + 1))
    .replace(/dd/g, formatNum(date.getDate()))
    .replace(/HH/g, formatNum(date.getHours()))
    .replace(/mm/g, formatNum(date.getMinutes()))
    .replace(/ss/g, formatNum(date.getSeconds()))
    .replace(/SSS/g, formatNum(date.getMilliseconds()))
}



// WEBPACK FOOTER //
// ./src/datas/tool.js